import { render } from "./MediaRuleConfig.vue?vue&type=template&id=72a32d46&ts=true"
import script from "./MediaRuleConfig.vue?vue&type=script&lang=ts"
export * from "./MediaRuleConfig.vue?vue&type=script&lang=ts"

import "./MediaRuleConfig.vue?vue&type=style&index=0&id=72a32d46&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__